// extracted by mini-css-extract-plugin
export default {"div":"checkbox_div__hYT89","innerDiv":"checkbox_innerDiv__lSjKm","span":"checkbox_span__FqPjk","label":"checkbox_label__xrbMr","p":"checkbox_p__M+SCN"};